var LAYOUTS = {
    JSON_FIXED: -3,
    DESIGNED_PRESET: -2,
    EMPTY: -1,
    COLLAGE: 0,
    MASONRY: 1,
    GRID: 2,
    THUMBNAIL: 3,
    SLIDER: 4,
    SLIDESHOW: 5,
    PANORAMA: 6,
    COLUMN: 7,
    MAGIC: 8,
    FULLSIZE: 9,
    BRICKS: 10,
    MIX: 11,
    ALTERNATE: 12,
};
var isLayout = function (layoutName) { return function (options) {
    // @ts-ignore
    return options.galleryLayout === LAYOUTS[layoutName];
}; };
export default LAYOUTS;
export { isLayout };
//# sourceMappingURL=layout.js.map